import React from 'react';
import './HowWeHelp.css';
import background from '../../Assets/background_images/background1.png';

function HiringAndSelection() {

  return (
    <div>
      <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
       <img className='image' src={background} alt='hiring' />
       <div className='heading'> Hiring and Selection </div>
      </div>

    <div> 
      <h1 className='title'>Hiring and Selection- It all starts here !  </h1> 
      <p className='paragraph'>
      Whether it's a start-up that builds a team from scratch or a successful company that needs to add talent, one of the main uses of evaluation is to screen new applicants during the recruitment and selection process. Personalized insights lead to better interviews, better hiring decisions, and help you hire more stars. 
      </p>

      <ul className='outer-list'>
        <li>The “top performer” attitude compared to the “average performer” increases productivity and profits by up to 67%. </li>
        <li>One in four considers productivity to be low, absenteeism, turnover, theft, fraud, violence, accidents, and other "high risks." </li>
        <li>In traditional interviews, there is a 50% success rate in hiring people who will be "excellent" or "excellent" employees.</li>
        <li>Interviews provide data on experience, skills, education, appearance, verbal communication, and background checks. </li>
        <li>
        What you can't see (and why you need a review) is to predict: 
          <ul className='inner-list'>
            <li>Someone's taste, urge, or personality </li>
            <li>Someone's behavior when no one is watching  </li>
            <li>Someone's behavior when no one is watching  </li>
          </ul>
        </li>
      </ul>
    </div> 
    <hr />

    <div> 
      <h1 className='title'> How Strategic Links can help: </h1> 
      
      <ul className='outer-list'>
        <li>Candidates can complete most exams in 10 minutes on any device, making it  easy  to extend their selection workflow.  </li>
        <li>You can  predict success by comparing the ideal range of scores for each job category. After all, sales reps need a different profile than the operations director. </li>
        <li>Find more innovative and visionary thinkers who can help improve  or change the direction of existing practices. </li>
        <li>The report contains individual interview questions to help you investigate your strengths and potential concerns.</li>
        <li>A better interview will help you make better hiring decisions. </li>
        <li>Take a look from Person-Job-Fit to Person-Organization-Fit. Identify candidates for your culture and build a strong and successful team.</li>
      </ul>
    </div> 
    </div>
  );
}

export default HiringAndSelection;
